// Image utility for easy icon access
// Import all SVG icons from the icons folder
import groupIcon from '@assets/icons/groupIcon.svg';
import revenueIcon from '@assets/icons/revenueIcon.svg';
import subscriptionIcon from '@assets/icons/subscriptionIcon.svg';
import tenantIcon from '@assets/icons/tenantIcon.svg';
import canadaFlag from '@assets/icons/canadaFlag.svg';
import australiaFlag from '@assets/icons/australiaFlag.svg';
import japanFlag from '@assets/icons/japanFlag.svg';
import arrowUp from '@assets/icons/arrowUp.svg';
import arrowDown from '@assets/icons/arrowDown.svg';
import barIcon from '@assets/icons/barIcon.svg';
import tickIcon from '@assets/icons/tickIcon.svg';

// Icon registry - maps icon names to their imported paths
const iconRegistry = {
    groupIcon,
    revenueIcon,
    subscriptionIcon,
    tenantIcon,
    canadaFlag,
    australiaFlag,
    japanFlag,
    barIcon,
    arrowUp,
    arrowDown,
    tickIcon,
};

/**
 * Get an icon by name
 * @param {string} iconName - Name of the icon (without .svg extension)
 * @returns {string} Icon path/URL
 * @example
 * getIcon('groupIcon') // returns the path to groupIcon.svg
 */
export const getIcon = (iconName) => {
    if (!iconName) {
        console.warn('getIcon: iconName is required');
        return null;
    }

    const icon = iconRegistry[iconName];
    if (!icon) {
        console.warn(`getIcon: Icon "${iconName}" not found. Available icons:`, Object.keys(iconRegistry));
        return null;
    }

    return icon;
};

/**
 * Get all available icon names
 * @returns {string[]} Array of available icon names
 */
export const getAvailableIcons = () => {
    return Object.keys(iconRegistry);
};

// Export individual icons for direct import
export { groupIcon, revenueIcon, subscriptionIcon, tenantIcon, arrowUp, arrowDown, barIcon, tickIcon };

// Export default registry for advanced usage
export default iconRegistry;

